import React, { useReducer } from 'react'
import ClinicalCares from '@/views/app/ClinicalCares'
import Terms from '@/views/app/ClinicalCares/Terms'
import Status from '@/views/app/ClinicalCares/Status'
import Form from '@/views/app/ClinicalCares/Form'
import { Redirect, Route, useRouteMatch } from 'react-router-dom'
import clinicalCareContext from '@/contexts/clinicalCareContext'
import clinicalCareReducer, { INITIAL_STATE } from '@/reducers/clinicalCare'
import Show from '@/views/app/ClinicalCares/Show'
import Death from '@/views/app/ClinicalCares/Show/Death'
import Cancel from '@/views/app/ClinicalCares/Show/Cancel'
import EventDetails from '@/views/app/ClinicalCares/Show/EventDetails'
import Approve from '@/views/app/ClinicalCares/Show/Approve'
import Triage from '@/views/app/ClinicalCares/Show/Triage'
import Pullout from '@/views/app/ClinicalCares/Show/Pullout'
import Done from '@/views/app/ClinicalCares/Show/Done'
import Clinics from '@/views/app/ClinicalCares/Clinics'
import Items from '@/views/app/ClinicalCares/Clinics/Items'
import Release from '@/views/app/ClinicalCares/Show/Release'
import ChangeClinic from '@/views/app/ClinicalCares/Show/ChangeClinic'
import ClinicalCaresItems from '@/views/app/ClinicalCares/ClinicalCareItems'
import ClinicalCarePanel from '@/views/app/ClinicalCares/Panel'
import Classifications from '@/views/app/ClinicalCares/Classifications'
import Reject from '@/views/app/ClinicalCares/Show/Reject'
import Revision from '@/views/app/ClinicalCares/Show/Revision'
import Correction from '@/views/app/ClinicalCares/Show/Correction'
import Messages from '@/views/app/Messages'

function ClinicalCaresRoutes() {
  const { path } = useRouteMatch()
  const [state, dispatch] = useReducer(clinicalCareReducer, INITIAL_STATE)

  return (
    <div>
      <Route exact path={path}>
        <ClinicalCares title="Petis - Parceiros / Atendimentos clínicos" />
      </Route>
      <Route exact path={`${path}/terms`}>
        <Terms title="Petis - Parceiros / Termos do Atendimento Clínico" />
      </Route>
      <Route exact path={[`${path}/messages`, `${path}/messages/:conversationId`]}>
        <Messages
          title="Petis - Parceiros / Atendimentos clínicos / Mensagens"
          type="clinicalCare"
          basePath={`${path}/messages`}
        />
      </Route>
      <Route exact path={`${path}/status`}>
        <Redirect to={path} />
      </Route>
      <Route exact path={`${path}/status/:status`}>
        <Status title="Petis - Parceiros / Atendimentos clínicos" />
      </Route>
      <Route exact path={`${path}/clinical-care-items`}>
        <ClinicalCaresItems title="Petis - Parceiros / Atendimentos clínicos / Itens clínicos" />
      </Route>
      <Route exact path={`${path}/classifications`}>
        <Classifications title="Petis - Parceiros / Atendimentos clínicos / Classificações" />
      </Route>
      <Route exact path={`${path}/clinics`}>
        <Clinics title="Petis - Parceiros / Atendimentos clínicos / Clínicas" />
      </Route>
      <Route path={`${path}/clinical-care-panel`}>
        <ClinicalCarePanel title="Petis - Parceiros / Atendimentos clínicos / Painel" />
      </Route>
      <Route exact path={`${path}/clinics/:id/items`}>
        <Items title="Petis - Parceiros / Atendimentos clínicos / Clínicas / Gerenciar itens clínicos" />
      </Route>
      <Route path={`${path}/form/add`}>
        <Form title="Petis - Parceiros / Atendimentos clínicos / Novo" />
      </Route>
      <clinicalCareContext.Provider value={{ state, dispatch }}>
        <Route path={`${path}/status/:status/:id`}>
          <Show title="Petis - Parceiros / Atendimentos clínicos / Atendimento clínico" />
        </Route>
        <Route path={`${path}/status/:status/:id/approve`}>
          <Approve title="Petis - Parceiros / Atendimentos clínicos / Atendimento clínico / Aprovar" />
        </Route>
        <Route path={`${path}/status/:status/:id/triage`}>
          <Triage title="Petis - Parceiros / Atendimentos clínicos / Atendimento clínico / Triagem" />
        </Route>
        <Route path={`${path}/status/:status/:id/change-clinic`}>
          <ChangeClinic title="Petis - Parceiros / Atendimentos clínicos / Atendimento clínico / Trocar clínica" />
        </Route>
        <Route path={`${path}/status/:status/:id/pullout`}>
          <Pullout title="Petis - Parceiros / Atendimentos clínicos / Atendimento clínico / Retirar" />
        </Route>
        <Route path={`${path}/status/:status/:id/release`}>
          <Release title="Petis - Parceiros / Atendimentos clínicos / Atendimento clínico / Alta médica" />
        </Route>
        <Route path={`${path}/status/:status/:id/done`}>
          <Done title="Petis - Parceiros / Atendimentos clínicos / Atendimento clínico / Concluir" />
        </Route>
        <Route path={`${path}/status/:status/:id/cancel`}>
          <Cancel title="Petis - Parceiros / Atendimentos clínicos / Atendimento clínico / Cancelar" />
        </Route>
        <Route path={`${path}/status/:status/:id/death`}>
          <Death title="Petis - Parceiros / Atendimentos clínicos / Atendimento clínico / Falecimento" />
        </Route>
        <Route path={`${path}/status/:status/:id/reject`}>
          <Reject title="Petis - Parceiros / Atendimentos clínicos / Atendimento clínico / Rejeitar" />
        </Route>
        <Route path={`${path}/status/:status/:id/revision`}>
          <Revision title="Petis - Parceiros / Atendimentos clínicos / Atendimento clínico / Vistoria" />
        </Route>
        <Route path={`${path}/status/:status/:id/correction`}>
          <Correction title="Petis - Parceiros / Atendimentos clínicos / Atendimento clínico / Correção" />
        </Route>
        <Route path={`${path}/status/:status/:id/events/:eventIndex`}>
          <EventDetails title="Petis - Parceiros / Atendimentos clínicos / Atendimento clínico / Detalhes do evento" />
        </Route>
      </clinicalCareContext.Provider>
    </div>
  )
}

export default ClinicalCaresRoutes
